<script setup lang="ts">
import { defineProps } from "vue/dist/vue";
import TextBase from "@/components/Texts/TextBase.vue";

const props = defineProps<{
  text: string;
}>();
</script>

<template>
  <TextBase class="text-lg md:text-xl" :text="props.text" />
</template>
